import React, { useMemo } from 'react';
import { Table } from 'new/elements/Table';
import { FileItemDetailsColumnsOptions, useFileItemDetails } from './index';
import Typography from 'new/elements/Typography';

import s from './FileItemDetails.module.scss';

interface Props {
  fileName: string;
  resourceId: number;
  resourceType: string;
  /**
   * Options for the columns to be displayed in the table
   * @default { shouldHideRecords: false }
   */
  columnsOptions?: FileItemDetailsColumnsOptions;
  parentScrollRef: React.RefObject<HTMLDivElement>;
}

export function FileItemDetails(props: Props) {
  const { resourceType, columnsOptions } = props;
  const [state, { generateColumns }] = useFileItemDetails(props);

  const { data, error, loading } = state;

  let content = null;

  if (error) {
    console.error('Error fetching file item details: FileItemDetails');
    return null;
  }

  if (loading || data === null) {
    content = (
      <div className={s.noDataContainer}>
        <Typography>Loading ingestion history...</Typography>
      </div>
    );
  }

  if (data?.length === 0 && !loading) {
    content = (
      <div className={s.noDataContainer}>
        <Typography>Ingestion history is not available</Typography>
      </div>
    );
  }

  if (data?.length) {
    content = (
      <div className={s.container} aria-label="file-item-details">
        <Table
          rows={data}
          loading={loading}
          disableVirtualization
          getRowClassName={() => s.tableRowText}
          columns={generateColumns(resourceType, columnsOptions)}
          parentScrollRef={props.parentScrollRef}
          localTableInnerContainerClassName={s.localTableInnerContainerClassName}
        />
      </div>
    );
  }

  return content;
}
